import { autoserialize } from 'cerialize';

export class SiteDetectionLabel {
  @autoserialize id!: number;
  @autoserialize label!: string;
  @autoserialize name!: string;
}
